export const ICON_OPTIONS = [
  { value: 'fa-arrow-right', label: 'Right arrow' },
  { value: 'fa-arrow-left', label: 'Left arrow' },
  { value: 'fa-chevron-right', label: 'Chevron right' },
  { value: 'fa-chevron-left', label: 'Chevron left' },
  { value: 'fa-download', label: 'Download' },
  { value: 'fa-shopping-cart', label: 'Shopping cart' },
  { value: 'fa-envelope', label: 'Envelope' },
  { value: 'fa-play', label: 'Play' },
  { value: 'fa-check', label: 'Check' },
  { value: 'fa-plus', label: 'Plus' },
  { value: 'fa-external-link-alt', label: 'External link' },
  { value: 'fa-heart', label: 'Heart' },
  { value: 'fa-star', label: 'Star' },
  { value: 'fa-search', label: 'Search' },
  { value: 'fa-paper-plane', label: 'Paper plane' },
  { value: 'fa-calendar-alt', label: 'Calendar' },
  { value: 'fa-phone', label: 'Phone' },
  { value: 'fa-user', label: 'User' },
  { value: 'fa-info-circle', label: 'Info' },
  { value: 'fa-file-download', label: 'File download' }
];